import React, { useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import { Button, Divider, InputAdornment } from '@material-ui/core';
import Formsy from 'formsy-react';
import { AutocompleteFormsy } from '../../../@fuse/components/formsy';
import { SILO_TYPES } from '../../constants/silo-types';
import { SILO_TYPE_REGIONS } from '../../constants/region-utils';
import { getUserRegion } from '../../../utils';
import { TextFieldFormsy } from '@fuse';
import { useCreateSilo, useMutateSilo } from '../../main/apps/FunctionalApps/silos/Silo.queries';
import buildSiloSubmitModel from './SiloForm.helpers';

const SiloForm = ({ editData, processors }) => {
    const history = useHistory();
    const showSiloTypes = SILO_TYPE_REGIONS.includes(getUserRegion());
    const [canSubmit, setCanSubmit] = useState(false);
    const { mutateAsync: update } = useMutateSilo();
    const { mutateAsync: create } = useCreateSilo();

    const disableButton = () => {
        setCanSubmit(false);
    };

    const enableButton = () => {
        setCanSubmit(true);
    };

    const onSubmit = async (model) => {
        const submitModel = buildSiloSubmitModel(model);

        try {
            if (editData) {
                await update({ _id: editData._id, ...submitModel });
            } else {
                await create(submitModel);
            }
            history.push({ pathname: '/list-silos' });
        } catch (err) {
            setCanSubmit(true);
        }
    };

    return (
        <div className="min-w-3/4 max-w-3/4">
            <Divider />

            <Formsy
                onValidSubmit={onSubmit}
                onValid={enableButton}
                onInvalid={disableButton}
                /* eslint-disable-next-line no-return-assign */
                ref={(form) => form}
                className="flex flex-col justify-center"
            >
                <TextFieldFormsy
                    className="my-16"
                    type="text"
                    name="silo_number"
                    label="Silo Number"
                    value={editData ? editData.silo_number : ''}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <i className="text-20 material-icons" color="action">
                                    person
                                </i>
                            </InputAdornment>
                        ),
                    }}
                    required
                    variant="outlined"
                />
                <AutocompleteFormsy
                    className="my-16"
                    name="processor_id"
                    label="Owner"
                    multiple={false}
                    options={processors.map((entry) => ({ value: entry.value, label: entry.name }))}
                    value={editData ? editData.processor_id : processors.length === 1 ? processors[0].value : null}
                    required
                    validations="isExisty"
                    validationError="Please select a Processor"
                    disabled={!!editData || processors.length === 1}
                />

                {showSiloTypes && <AutocompleteFormsy className="my-16" name="silo_types" label="Silo Types" options={SILO_TYPES} value={editData?.silo_types ?? []} required validations="minLength:1" validationError="Select at least one silo type" />}

                <TextFieldFormsy
                    className="my-16"
                    type="text"
                    name="capacity"
                    label="Capacity"
                    value={editData ? editData.capacity : ''}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <i className="text-20 material-icons" color="action">
                                    bookmark
                                </i>
                            </InputAdornment>
                        ),
                    }}
                    variant="outlined"
                />

                <Button type="submit" variant="contained" color="primary" className="mx-auto my-16" aria-label={editData ? 'EDIT SUB USER' : 'ADD SUB USER'} disabled={!canSubmit}>
                    {editData ? 'Edit Silo' : 'Add Silo'}
                </Button>
            </Formsy>
        </div>
    );
};

export default withRouter(SiloForm);
